
const mutations = {
  setTourResearchForm(state, form) {
    state.tour.researchForm = form
  },
  setTourForm(state, query) {
    const {
      flightVariantId,
      hotelVariantId,
      transferVariantId,
      insuranceVariantId,
      visaVariantId,
      tourTemplateId,
      tourType
    } = query

    state.tour.form = {
      ...state.tour.form,
      flightVariantId,
      hotelVariantId,
      transferVariantId,
      insuranceVariantId,
      visaVariantId,
      tourTemplateId,
      tourType
    }
  }
}

export default mutations